import { configure as configureInterceptors } from './interceptors'
export const configure = () => {
    configureInterceptors();
}